import * as Sentry from '@sentry/react'

const dsn = import.meta.env.VITE_SENTRY_DSN

// Reset links carry their secret in the URL fragment and arrive as a full page load from the email
const onRecoveryPage = /^\/(forgot|reset)-password\/*$/i.test(window.location.pathname)

/** Redacts reset tokens, e.g. from a second link pasted into an open reset tab (a same-document hash change). */
export function scrubResetToken<T>(data: T): T | null {
  try {
    return JSON.parse(JSON.stringify(data).replace(/token=[\w-]+/g, 'token=[redacted]'))
  } catch {
    return null // unserializable: drop it rather than risk sending a token
  }
}

if (dsn && import.meta.env.PROD && !onRecoveryPage) {
  Sentry.init({
    dsn,
    tunnel: '/sentry/api/4511711695339520/envelope/',
    environment: import.meta.env.MODE,
    beforeSend: scrubResetToken,
    beforeSendTransaction: scrubResetToken,
    beforeBreadcrumb: scrubResetToken,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        maskAllInputs: true,
        blockAllMedia: true,
        // Recording events can be large, so only scrub while a token is in the address bar
        beforeAddRecordingEvent: (event) => window.location.hash.includes('token=') ? scrubResetToken(event) : event,
      }),
    ],
    tracesSampleRate: 0.2,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  })
}

export default Sentry
